export default __webpack_public_path__ + "static/meetYourNewDigitalProfile-c8f8adf9ddb5b917b99e6d192563893b.png";